import { Collapse } from "antd";
import "./Accordion.css";
const Accordion = () => {
  const items = [
    {
      key: "1",
      label: "What is Ethereum?",
      children: (
        <p>
          Ethereum is a digital currency and technology that lets people send
          money and own digital items online. Think of it like the internet’s
          version of money — fast, secure, and global.
        </p>
      ),
    },
    {
      key: "2",
      label: "What is MetaMask?",
      children: (
        <div>
          <p>
            MetaMask is a digital wallet you install as a browser extension or
            mobile app. It lets you safely store your Ethereum and manage your
            NFTs. It’s like your secure online wallet for the XR objects you
            buy.
          </p>
          <div style={{ marginTop: "15px" }}>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/YVgfHZMFFFQ"
              title="MetaMask Tutorial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: "What are NFTs?",
      children: (
        <div>
          <p>
            NFTs (Non-Fungible Tokens) are unique digital items stored on the
            blockchain. In simple terms, NFTs prove you OWN a digital objects —
            just like having the original painting, not a copy.
          </p>
          <div style={{ marginTop: "15px" }}>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/FkUn86bH34M"
              title="MetaMask Tutorial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      ),
    },
    {
      key: "4",
      label: "Why do I need Ethereum to buy XR objects?",
      children: (
        <p>
          You use Ethereum (ETH) to purchase NFTs. It works the same way you use
          dollars or euros to buy things in shops — but here, it's digital.
        </p>
      ),
    },

    {
      key: "5",
      label: "How do I get started?",
      children: (
        <div>
          <p>Install MetaMask (Chrome, Firefox, or mobile app) </p>
          <p>Create your wallet and save your secret phrase</p>
          <p>
            Buy Ethereum (ETH) in MetaMask or transfer from another exchange{" "}
          </p>
          <p>
            Connect MetaMask to our platform Browse XR2Learn Objects → choose a
            piece → buy!{" "}
          </p>

          <div style={{ marginTop: "15px" }}>
            <iframe
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/GNPz-Dv5BjM"
              title="MetaMask Tutorial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      ),
    },
    {
      key: "6",
      label: "Is MetaMask safe?",
      children: (
        <p>
          Yes — MetaMask is trusted by millions of users worldwide. Just make
          sure to never share your secret recovery phrase with anyone.{" "}
        </p>
      ),
    },
    {
      key: "7",
      label: "What happens after I buy NFT XR object?",
      children: (
        <p>
          Once you complete your purchase: The NFT is sent to your MetaMask
          wallet You officially own the XR object You can view it, show it, or
          sell it later.
        </p>
      ),
    },
    // {
    //   key: "8",
    //   label: "Can I sell the NFT later?",
    //   children: (
    //     <p>
    //       Yes! You can list your NFT on our platform or any compatible NFT
    //       marketplace and sell it when you want.
    //     </p>
    //   ),
    // },

    // {
    //   key: "10",
    //   label: "Can I sell the NFT later?",
    //   children: (
    //     <p>
    //       Yes! You can list your NFT on our platform or any compatible NFT
    //       marketplace and sell it when you want.
    //     </p>
    //   ),
    // },
  ];

  return (
    <Collapse
      className="custom-accordion"
      style={{ width: "900px " }}
      accordion
      items={items}
    />
  );
};

export default Accordion;
